import { deriveCatalogOwnership } from '../chunk-MULXZLEI.js';
import { RESOLVE_SCOPE_LABEL, policyFor } from '../chunk-VHUWJJDD.js';
export { ATTRIBUTION_POLICIES, DISABLED_RESOURCE_POLICY, READ_SCOPE_TO_ANALYTICS, RECORD_RESOURCES, RECORD_RUNG_LABEL, RECORD_TIER_TO_READ_SCOPE, RESOLVE_SCOPE_LABEL, SCOPE_HINT_FLAG, SCOPE_PROVENANCE_LABEL, WORKSPACE_RESOLVE_SCOPE_LABEL, WORKSPACE_WRITE_SCOPE_LABEL, WRITE_PATH, WRITE_SCOPE_LABEL, WRITE_SCOPE_MEANING, WRITE_SCOPE_RUNG, WRITE_SCOPE_TO_ANALYTICS, attributionLadderGap, attributionPolicies, isRecordResource, policyFor, primaryWriteRung, provenanceLabel, readScopeResources, readScopeRung, recordRungLabel, resolveReadScope, resolveScopeLabel, resolveWriteScope, resourcePolicy, tierWeightToScope, writeScopeLabel, writeScopeResources } from '../chunk-VHUWJJDD.js';
import { isDefaultedField } from '../chunk-5DN52UUN.js';
import '../chunk-UTUWSDJD.js';
import '../chunk-V5XVQC3T.js';
import '../chunk-MY2WTNZQ.js';
import '../chunk-KBORZRSN.js';
import '../chunk-BJ3WKLB6.js';
import '../chunk-INX63VAT.js';
import '../chunk-4H24VLPN.js';
import '../chunk-EECZD6AJ.js';
import '../chunk-DKHPA5JM.js';
import '../chunk-XR6TNFQL.js';
import '../chunk-HIWBYL4O.js';
import '../chunk-WYAZTERB.js';
import { recordedConfidence } from '../chunk-X34AGPO3.js';
import '../chunk-BRBMP7SU.js';
import '../chunk-MZH5OJVQ.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-HCZGW64N.js';
import '../chunk-P7JJLTIL.js';
import '../chunk-IQZNGZOU.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-EE4CQDCZ.js';
import { Severity } from '../chunk-6B5KO6TH.js';
import '../chunk-3QN2VZ56.js';
import '../chunk-LNDNXOJP.js';
import '../chunk-LVCDLPYA.js';
import '../chunk-UEXNJL5R.js';
import '../chunk-FY45KRBV.js';
import '../chunk-ZOKU2MUA.js';
import '../chunk-O2TUCS6S.js';
import { normalizeAddress } from '../chunk-7S35BX3Z.js';
import '../chunk-J77YJ7IT.js';
import '../chunk-DXLSREFI.js';
import '../chunk-GPJ572YS.js';
import { brandClass } from '../chunk-N7SZ66QO.js';
import '../chunk-LD6PO66H.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-O5TCTRWM.js';
import '../chunk-O3OIBNP7.js';
import '../chunk-PZ5AY32C.js';

// src/attribution/model.ts
var ATTRIBUTION_KINDS = [
  "tag",
  "label",
  "group",
  "entity"
];
var WRITABLE_SUBJECT_KINDS = [
  "address",
  "transaction",
  "entity",
  "event",
  "internal_tx"
];
function isWritableSubject(subject) {
  return WRITABLE_SUBJECT_KINDS.includes(subject.kind);
}
var KIND_LABEL = {
  tag: "tag",
  label: "label",
  group: "group",
  entity: "entity"
};
var KIND_LABEL_PLURAL = {
  tag: "tags",
  label: "labels",
  group: "groups",
  entity: "entities"
};
var ASSIGNMENT_ATTRIBUTE_KEYS = Object.keys({
  visibility: 0,
  confidence: 0,
  reason: 0,
  evidenceUrl: 0,
  validFrom: 0,
  validTo: 0
});
function subjectKey(subject) {
  switch (subject.kind) {
    case "address":
      return `address:${subject.chainId}:${normalizeAddress(subject.address, subject.chainId)}`;
    case "transaction":
      return `transaction:${subject.canonicalTxId}`;
    case "entity":
      return `entity:${subject.entityId}`;
    case "event":
      return `event:${subject.chainId ?? "_"}:${subject.canonicalTxId}:${subject.logIndex}`;
    case "internal_tx":
      return `internal_tx:${subject.canonicalTxId}:${subject.internalIndex}`;
  }
}
function effectiveWriteScope(preferred, options) {
  return options.shared && preferred === "private" ? "tenant" : preferred;
}
function subjectTargetId(subject) {
  switch (subject.kind) {
    case "address":
      return subject.address;
    case "transaction":
      return subject.canonicalTxId;
    case "entity":
      return subject.entityId;
    case "event":
      return `${subject.canonicalTxId}#evt#${subject.logIndex}`;
    case "internal_tx":
      return `${subject.canonicalTxId}#int#${subject.internalIndex}`;
  }
}
function subjectChainId(subject) {
  switch (subject.kind) {
    case "address":
      return subject.chainId;
    case "event":
      return subject.chainId;
    // A transaction-scope assignment is chain-agnostic in commons, and an
    // entity spans chains by definition. Sending a chain for either writes a
    // key the read side does not rebuild.
    default:
      return void 0;
  }
}

// src/attribution/capability.ts
var BELIEF = [
  "confidence",
  "reason",
  "evidenceUrl"
];
var WINDOW = ["validFrom", "validTo"];
var EMPTY = [];
var TABLE = {
  address: {
    default: ["visibility", ...BELIEF, ...WINDOW],
    // A tag files an address under a heading; it does not assert a fact with a
    // lifetime, so no window.
    tag: ["visibility", ...BELIEF]
  },
  transaction: {
    // No visibility: the tx patch route has no ABAC carriers.
    default: BELIEF,
    tag: BELIEF
  },
  entity: {
    default: ["visibility", ...BELIEF, ...WINDOW],
    tag: ["visibility", ...BELIEF]
  },
  event: {
    default: BELIEF
  },
  internal_tx: {
    default: BELIEF
  }
};
function attributionCapability(subject, kind) {
  const row = TABLE[subject.kind];
  return { accepts: row[kind] ?? row.default, requires: EMPTY };
}
function capabilityAccepts(subject, kind, attribute) {
  return attributionCapability(subject, kind).accepts.includes(attribute);
}
function pruneToCapability(subject, kind, attributes) {
  const { accepts } = attributionCapability(subject, kind);
  const out = {};
  for (const key of Object.keys(attributes)) {
    if (accepts.includes(key)) {
      Object.assign(out, { [key]: attributes[key] });
    }
  }
  return out;
}
function missingRequired(subject, kind, attributes) {
  return attributionCapability(subject, kind).requires.filter((key) => {
    const value = attributes[key];
    return value === void 0 || value === null || value === "";
  });
}

// src/attribution/eligibility.ts
var ADDRESS_BOUND_SUBJECTS = [
  "address",
  "entity"
];
var addressBoundStaysOnAddresses = (subject, _kind, item) => !ADDRESS_BOUND_SUBJECTS.includes(subject.kind) && item.address ? "Bound to an address \u2014 attach it to the address instead" : null;
var RULES = [addressBoundStaysOnAddresses];
function attributionRejection(subject, kind, item) {
  for (const rule of RULES) {
    const reason = rule(subject, kind, item);
    if (reason) return reason;
  }
  return null;
}

// src/attribution/candidates.ts
var CANDIDATE_LIMIT = 20;
function toAttributionCandidate(row) {
  const r = row ?? {};
  const id = String(r.id ?? "");
  const text = (key) => {
    const value = r[key];
    return value == null || value === "" ? void 0 : String(value);
  };
  return {
    id,
    name: text("name") ?? id,
    color: text("color"),
    address: text("address"),
    // The same derivation the catalog list's Source column uses, so a picker
    // and a list never disagree about which rung a row came from.
    origin: deriveCatalogOwnership(r).label
  };
}
function attributionCandidateLoader(list, subject) {
  return async (kind, search) => {
    const rows = await list(kind, { search, limit: CANDIDATE_LIMIT });
    return rows.map((row) => {
      const candidate = toAttributionCandidate(row);
      const ineligible = subject ? attributionRejection(subject, kind, candidate) : null;
      return {
        id: candidate.id,
        name: candidate.name ?? candidate.id,
        ...candidate.color ? { color: candidate.color } : {},
        ...candidate.address ? { address: candidate.address } : {},
        ...candidate.origin ? { origin: candidate.origin } : {},
        ...ineligible ? { ineligible } : {}
      };
    });
  };
}

// src/attribution/wire.ts
function defined(source) {
  const out = {};
  for (const [key, value] of Object.entries(source)) {
    if (value !== void 0 && value !== "") out[key] = value;
  }
  return out;
}
function clearedAttributes(previous, next) {
  if (!previous) return [];
  const empty = (value) => value === void 0 || value === null || value === "";
  return Object.keys(previous).filter(
    (key) => !empty(previous[key]) && empty(next[key])
  );
}
function effectiveVisibilityScope(visibility) {
  const named = visibility.teamIds?.length ?? 0;
  return visibility.scope === "team" && named === 0 ? "private" : visibility.scope;
}
function restVisibility(visibility) {
  if (!visibility) return {};
  switch (effectiveVisibilityScope(visibility)) {
    case "private":
      return { user_scoped: true };
    case "team":
      return {
        user_scoped: true,
        visible_to_team_ids: [...visibility.teamIds ?? []]
      };
    case "tenant":
      return { user_scoped: false };
    // `user_scoped` has ONE bit, so a shared rung is NAMED: without it an org-
    // or customer-wide choice would write the same tenant-wide row. The backend
    // places the row in that rung's partition (catalog promote grant required).
    case "org":
      return { user_scoped: false, rung: "org" };
    case "customer":
      return { user_scoped: false, rung: "customer" };
  }
}
function recordVisibilityReport(visibility, fallback = "private") {
  const requested = visibility?.scope ?? fallback;
  const effective = effectiveVisibilityScope(visibility ?? { scope: fallback });
  const { scope, visibleToTeamIds } = recordVisibility(visibility, fallback);
  return {
    scope,
    visibleToTeamIds,
    requested,
    effective,
    ...effective !== requested ? { downgraded: { from: requested, to: effective, reason: "no-teams" } } : {}
  };
}
function recordVisibility(visibility, fallback = "private") {
  const teamIds = [...visibility?.teamIds ?? []];
  switch (effectiveVisibilityScope(visibility ?? { scope: fallback })) {
    case "private":
      return { scope: "user", visibleToTeamIds: [] };
    case "team":
      return { scope: "user", visibleToTeamIds: teamIds };
    case "tenant":
      return { scope: "tenant", visibleToTeamIds: [] };
    case "org":
      return { scope: "org", visibleToTeamIds: [] };
    case "customer":
      return { scope: "customer", visibleToTeamIds: [] };
  }
}
var WIRE_ATTRIBUTE_NAME = {
  confidence: "confidence",
  reason: "reason",
  evidenceUrl: "evidence_url",
  validFrom: "valid_from",
  validTo: "valid_to"
};
function clearedWireNames(cleared) {
  return cleared.map((key) => WIRE_ATTRIBUTE_NAME[key]).filter((name) => Boolean(name));
}
function toRestBody(attributes, cleared = []) {
  const fields_cleared = clearedWireNames(cleared);
  return {
    ...defined({
      confidence: attributes.confidence,
      reason: attributes.reason,
      evidence_url: attributes.evidenceUrl,
      valid_from: attributes.validFrom,
      valid_to: attributes.validTo
    }),
    ...fields_cleared.length > 0 ? { fields_cleared } : {},
    ...restVisibility(attributes.visibility)
  };
}
function toGraphqlInput(attributes) {
  const rest = restVisibility(attributes.visibility);
  return defined({
    userScoped: rest.user_scoped,
    rung: rest.rung ? rest.rung.toUpperCase() : void 0,
    visibleToUserIds: rest.visible_to_user_ids,
    visibleToTeamIds: rest.visible_to_team_ids,
    confidence: attributes.confidence,
    reason: attributes.reason,
    evidenceUrl: attributes.evidenceUrl,
    validFrom: attributes.validFrom,
    validTo: attributes.validTo
  });
}
function toTxAttach(catalogId, attributes = {}, cleared = []) {
  const fields_cleared = clearedWireNames(cleared);
  const provenance = defined({
    confidence: attributes.confidence,
    reason: attributes.reason,
    evidence_url: attributes.evidenceUrl,
    valid_from: attributes.validFrom,
    valid_to: attributes.validTo
  });
  if (fields_cleared.length > 0) provenance.fields_cleared = fields_cleared;
  return Object.keys(provenance).length === 0 ? catalogId : { catalog_id: catalogId, ...provenance };
}
var TX_PATCH_FIELDS = {
  tag: { add: "tags_add", remove: "tags_remove" },
  label: { add: "labels_add", remove: "labels_remove" },
  group: { add: "groups_add", remove: "groups_remove" },
  entity: { add: "entities_add", remove: "entities_remove" }
};
function txPatchBody(kind, catalogId, op, attributes = {}, cleared = []) {
  return {
    [TX_PATCH_FIELDS[kind][op]]: [
      op === "add" ? toTxAttach(catalogId, attributes, cleared) : catalogId
    ]
  };
}

// src/attribution/hintState.ts
function writeHintState(subject, kinds, defaultVisibility, options = {}) {
  const configurable = kinds.filter((kind) => capabilityAccepts(subject, kind, "visibility"));
  if (configurable.length === 0) {
    return { kind: "fixed", perKind: [], teamIds: [], raised: false };
  }
  const resolved = configurable.map((kind) => ({ kind, visibility: defaultVisibility(kind) }));
  const perKind = resolved.map(({ kind, visibility }) => ({ kind, scope: visibility.scope }));
  const scopes = [...new Set(perKind.map((e) => e.scope))];
  const raised = Boolean(
    options.shared && options.configuredScope && resolved.some(
      ({ kind, visibility }) => visibility.scope === "tenant" && options.configuredScope?.(kind) === "private"
    )
  );
  return {
    kind: scopes.length === 1 ? "uniform" : "mixed",
    ...scopes.length === 1 ? { scope: scopes[0] } : {},
    perKind,
    teamIds: resolved.find((e) => e.visibility.scope === "team")?.visibility.teamIds ?? [],
    raised
  };
}
function readHintState(policy, scope) {
  return {
    visible: policy.enabled && policy.resolvedView,
    scope,
    ownView: scope === "USER"
  };
}
function surfaceHintState(records, subjects) {
  const tiers = new Set(subjects.map((each) => each.scope));
  const agreed = tiers.size === 1 ? subjects[0] : void 0;
  return {
    mismatched: Boolean(records.writesLandIn) && records.writesLandIn !== records.label,
    attributionNotable: !agreed || !agreed.ownView && RESOLVE_SCOPE_LABEL[agreed.scope] !== records.label,
    ...agreed ? { scope: agreed.scope } : {},
    ownView: Boolean(agreed?.ownView)
  };
}

// src/attribution/plan.ts
var IneligibleAttributionError = class extends Error {
  static {
    brandClass(this, "attribution/IneligibleAttributionError");
  }
  constructor(reason) {
    super(reason);
    this.name = "IneligibleAttributionError";
  }
};
var UnsupportedSubjectError = class extends Error {
  constructor(subjectKind) {
    super(`Attribution isn't supported on ${SUBJECT_NOUN[subjectKind] ?? "this"} yet.`);
    this.subjectKind = subjectKind;
    this.name = "UnsupportedSubjectError";
  }
  subjectKind;
  static {
    brandClass(this, "attribution/UnsupportedSubjectError");
  }
};
var ATTRIBUTE_PROBE = {
  visibility: { scope: "private" },
  confidence: 0,
  reason: "",
  evidenceUrl: "",
  validFrom: 0,
  validTo: 0
};
var SUBJECT_NOUN = {
  entity: "an entity",
  event: "an event",
  internal_tx: "an internal transaction"
};
function addressRef(subject, what) {
  if (subject.kind !== "address") {
    throw new Error(`${what} applies to an address, not a ${subject.kind}`);
  }
  return { chainId: subject.chainId, address: subject.address };
}
function planAttribution(write, defaults = {}) {
  const { subject, kind, candidate, target = "overlay" } = write;
  if (!isWritableSubject(subject)) throw new UnsupportedSubjectError(subject.kind);
  const rejection = attributionRejection(subject, kind, candidate);
  if (rejection) throw new IneligibleAttributionError(rejection);
  const attributes = pruneToCapability(subject, kind, {
    ...defaults,
    ...write.attributes
  });
  const accepted = new Set(Object.keys(pruneToCapability(subject, kind, ATTRIBUTE_PROBE)));
  const cleared = (write.cleared ?? []).filter((key) => accepted.has(key));
  switch (target) {
    case "overlay":
      if (subject.kind === "transaction") {
        return {
          route: "tx-overlay",
          canonicalTxId: subject.canonicalTxId,
          kind,
          catalogId: candidate.id,
          attributes,
          cleared
        };
      }
      if (subject.kind === "address") {
        return {
          route: "address-overlay",
          ref: addressRef(subject, "a catalog overlay"),
          kind,
          catalogId: candidate.id,
          attributes,
          cleared
        };
      }
      return {
        route: "catalog-assignment",
        scope: subject.kind,
        targetId: subjectTargetId(subject),
        chainId: subjectChainId(subject),
        kind,
        catalogId: candidate.id,
        attributes,
        cleared
      };
    case "primary":
      return {
        route: "primary",
        ref: addressRef(subject, "a primary pointer"),
        entityId: candidate.id
      };
    case "membership":
      return {
        route: "membership",
        ref: addressRef(subject, "an entity membership"),
        entityId: candidate.id,
        attributes,
        // Trimmed here rather than at the form: a role of spaces is the same
        // statement as no role, and only one of the two round-trips as one.
        role: write.role?.trim() || void 0
      };
  }
}

// src/attribution/bulk.ts
var MAX_BULK_SUBJECTS = 100;
var CONCURRENCY = 4;
async function applyToMany(subjects, apply) {
  const outcome = { applied: [], failed: [] };
  const queue = [...subjects];
  const worker = async () => {
    for (; ; ) {
      const subject = queue.shift();
      if (subject === void 0) return;
      try {
        await apply(subject);
        outcome.applied.push(subject);
      } catch (reason) {
        outcome.failed.push({ subject, reason });
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(CONCURRENCY, subjects.length) }, worker));
  return outcome;
}
function outcomeMessage(outcome, verbPast) {
  const total = outcome.applied.length + outcome.failed.length;
  return outcome.failed.length === 0 ? `${total} ${verbPast}` : `${outcome.applied.length} of ${total} ${verbPast} \u2014 ${outcome.failed.length} failed`;
}

// src/attribution/chips.ts
var SEVERITIES = Object.values(Severity);
var BUNDLE_KEY = {
  entity: "entities",
  label: "labels",
  tag: "tags",
  group: "groups"
};
var NO_ATTACHMENTS = {
  tag: [],
  label: [],
  group: [],
  entity: []
};
function toCatalogChip(item) {
  if (typeof item === "string") return item ? { id: item, name: item } : null;
  if (item && typeof item === "object") {
    const o = item;
    const id = String(o.id ?? o.catalog_id ?? "");
    if (!id) return null;
    const name = o.name == null || o.name === "" ? id : String(o.name);
    const color = o.color == null || o.color === "" ? void 0 : String(o.color);
    return { id, name, color, ...chipProvenance(o) };
  }
  return null;
}
function readGlassBoxProvenance(o) {
  const confidence = typeof o.confidence === "number" && Number.isFinite(o.confidence) ? o.confidence : void 0;
  const explanation = Array.isArray(o.explanation) ? o.explanation.filter((b) => typeof b === "string" && b !== "") : [];
  const lifecycle = o.lifecycle == null || o.lifecycle === "" ? void 0 : String(o.lifecycle);
  return {
    confidence,
    confidence_status: o.confidence_status === "scored" || o.confidence_status === "unscored" ? o.confidence_status : void 0,
    explanation: explanation.length > 0 ? explanation : void 0,
    lifecycle
  };
}
function chipProvenance(o) {
  return readGlassBoxProvenance(o);
}
function catalogChipsFrom(items) {
  if (!Array.isArray(items)) return [];
  return items.map(toCatalogChip).filter((c) => c !== null);
}
function attachedFromCatalogBlock(block) {
  const b = block ?? {};
  return {
    tag: catalogChipsFrom(b.tags),
    label: catalogChipsFrom(b.labels),
    group: catalogChipsFrom(b.groups),
    entity: catalogChipsFrom(b.entities)
  };
}
function attributionBundle(attached) {
  return {
    tags: attached.tag,
    labels: attached.label,
    groups: attached.group,
    entities: attached.entity
  };
}
function foldPrimaryEntity(attached, primaryEntityId) {
  const primary = primaryEntityId || void 0;
  if (!primary || attached.entity.some((chip) => chip.id === primary)) return { attached };
  return {
    // First, because it is the headline.
    attached: { ...attached, entity: [{ id: primary, name: primary }, ...attached.entity] },
    foldedPrimary: primary
  };
}
function attachedFromAssignments(rows, options = {}) {
  const attached = { tag: [], label: [], group: [], entity: [] };
  const seen = {
    tag: /* @__PURE__ */ new Set(),
    label: /* @__PURE__ */ new Set(),
    group: /* @__PURE__ */ new Set(),
    entity: /* @__PURE__ */ new Set()
  };
  for (const row of rows) {
    const kind = String(row.catalog_kind ?? "");
    const id = row.catalog_id == null ? "" : String(row.catalog_id);
    if (!id || !(kind in attached) || seen[kind].has(id)) continue;
    seen[kind].add(id);
    attached[kind].push({ id, name: id });
  }
  return foldPrimaryEntity(attached, options.primaryEntityId);
}
function namedAttributionBundle(attached, lookup, options = {}) {
  const { primaryEntityId, fallbackName } = options;
  const items = (kind) => attached[kind].map((chip) => {
    const row = lookup(kind, chip.id);
    const own = chip.name && chip.name !== chip.id ? chip.name : void 0;
    return {
      id: chip.id,
      name: row?.name ?? own ?? fallbackName?.(chip.id) ?? chip.id,
      ...row?.color ?? chip.color ? { color: row?.color ?? chip.color } : {},
      ...kind === "entity" && primaryEntityId && chip.id === primaryEntityId ? { isPrimary: true } : {}
    };
  });
  return {
    entities: items("entity"),
    labels: items("label"),
    tags: items("tag"),
    groups: items("group")
  };
}
function overlayAttributionBundle(overlays) {
  const primaryOf = (kind) => overlays.primary?.find((p) => p.kind === kind)?.catalogId;
  return {
    entities: (overlays.entities ?? []).map((e) => ({
      id: e.id,
      name: e.name || e.id,
      logo: e.logo,
      color: e.color,
      confidence: e.confidence,
      confidence_status: e.confidence_status,
      entityType: e.type,
      isPrimary: e.id === primaryOf("entity")
    })),
    tags: (overlays.tags ?? []).map((h) => hitChip(h, primaryOf("tag"))),
    labels: (overlays.labels ?? []).map((h) => hitChip(h, primaryOf("label"))),
    groups: (overlays.groups ?? []).map((h) => hitChip(h, primaryOf("group")))
  };
}
function severityOf(value) {
  const key = typeof value === "string" ? value.toLowerCase() : "";
  return SEVERITIES.includes(key) ? { severity: key } : {};
}
function hitChip(hit, primaryId) {
  return {
    id: hit.catalogId,
    name: hit.name || hit.catalogId,
    color: hit.color,
    logo: hit.logo,
    confidence: hit.confidence,
    confidence_status: hit.confidence_status,
    lifecycle: hit.lifecycle,
    explanation: hit.explanation,
    // The weight behind the name. A label is not only a name — `Sanctioned: OFAC`
    // is an accusation — and this is the one field on the chip that is not
    // cosmetic. Absent stays absent: no severity is not `info`.
    ...severityOf(hit.severity),
    // The resolver already marks the winner; `primary` on the bundle is the
    // curated pointer. Either one makes this the headline.
    isPrimary: Boolean(hit.isPrimary) || hit.catalogId === primaryId
  };
}

// src/attribution/writer.ts
function createAttributionWriter(ports) {
  const { addresses, patchTransaction, invalidate, defaultVisibility } = ports;
  const primaryAt = () => {
    const rung = ports.primaryRung?.();
    return rung ? { rung } : {};
  };
  const send = async (plan) => {
    switch (plan.route) {
      case "address-overlay":
        await addresses.attachAssignment(plan.ref.chainId, plan.ref.address, {
          catalog_kind: plan.kind,
          catalog_id: plan.catalogId,
          ...toRestBody(plan.attributes, plan.cleared)
        });
        return;
      case "tx-overlay":
        await patchTransaction(
          plan.canonicalTxId,
          txPatchBody(plan.kind, plan.catalogId, "add", plan.attributes, plan.cleared)
        );
        return;
      case "catalog-assignment": {
        if (!ports.postCatalogAssignment) {
          throw new Error(
            `[attribution] this host cannot attribute a ${plan.scope}: no catalog-assignments port`
          );
        }
        await ports.postCatalogAssignment({
          scope: plan.scope,
          target_id: plan.targetId,
          ...plan.chainId ? { chain_id: plan.chainId } : {},
          catalog_kind: plan.kind,
          catalog_id: plan.catalogId,
          ...toRestBody(plan.attributes, plan.cleared)
        });
        return;
      }
      case "primary":
        await addresses.setPrimary(plan.ref.chainId, plan.ref.address, plan.entityId, primaryAt());
        return;
      case "membership":
        await addresses.putEntityMapping(plan.ref.chainId, plan.ref.address, {
          entity_id: plan.entityId,
          role: plan.role,
          confidence: plan.attributes.confidence,
          valid_from: plan.attributes.validFrom,
          valid_to: plan.attributes.validTo
        });
    }
  };
  return {
    async assign(write) {
      await send(planAttribution(write, { visibility: defaultVisibility(write.kind) }));
      invalidate(write.subject);
    },
    async unassign(subject, kind, catalogId, target = "overlay") {
      switch (target) {
        case "overlay":
          if (subject.kind === "transaction") {
            await patchTransaction(
              subject.canonicalTxId,
              txPatchBody(kind, catalogId, "remove", {})
            );
          } else if (subject.kind !== "address") {
            if (!ports.deleteCatalogAssignment) {
              throw new Error(
                `[attribution] this host cannot detach from a ${subject.kind}: no catalog-assignments port`
              );
            }
            await ports.deleteCatalogAssignment({
              scope: subject.kind,
              target_id: subjectTargetId(subject),
              ...subjectChainId(subject) ? { chain_id: subjectChainId(subject) } : {},
              catalog_kind: kind,
              catalog_id: catalogId
            });
          } else {
            const ref = addressRef(subject, "a catalog overlay");
            await addresses.detachAssignment(ref.chainId, ref.address, {
              catalog_kind: kind,
              catalog_id: catalogId
              // No lane named on purpose. Whether the overlay went to the
              // caller's private partition or the tenant-wide one was decided by
              // the write scope in force at attach time and is not carried on a
              // resolved read — and a delete aimed at a key that does not exist
              // SUCCEEDS. Guessing here is what made a tenant-wide chip
              // undeletable while every layer reported success.
            });
          }
          break;
        case "primary": {
          const ref = addressRef(subject, "a primary pointer");
          await addresses.clearPrimary(ref.chainId, ref.address, catalogId, primaryAt());
          break;
        }
        case "membership": {
          const ref = addressRef(subject, "an entity membership");
          await addresses.deleteEntityMapping(ref.chainId, ref.address, catalogId);
          break;
        }
      }
      invalidate(subject);
    },
    async setMembership(subject, input) {
      const ref = addressRef(subject, "an entity membership");
      await addresses.putEntityMapping(ref.chainId, ref.address, input);
      invalidate(subject);
    },
    async hidePrimary(subject, entityId) {
      const ref = addressRef(subject, "a primary pointer");
      await addresses.setPrimary(ref.chainId, ref.address, entityId, {
        ...primaryAt(),
        noAddress: true
      });
      invalidate(subject);
    }
  };
}

// src/attribution/policy.ts
var POLICY_RUNGS = ["customer", "org", "tenant"];
var POLICY_RESOURCES = [
  "transaction",
  "address",
  "entity",
  "label",
  "tag",
  "group",
  "primary",
  "protocol",
  "tracer",
  "alertRule",
  "groupingRule",
  "pipeline",
  "savedView"
];
var POLICY_WRITE_TIERS = [
  "private",
  "team",
  "tenant",
  "org",
  "customer"
];
var POLICY_READ_TIERS = [
  "USER",
  "TENANT",
  "ORG",
  "CUSTOMER",
  "GLOBAL"
];
var POLICY_VIOLATION_CODE = "VISIBILITY_POLICY";
function isVisibilityPolicyRefusal(error) {
  if (!error || typeof error !== "object") return false;
  const envelope = error.envelope;
  const body = envelope?.error ?? error.error;
  const own = error;
  return [body?.error_code, body?.code, own.code, own.error_code].includes(POLICY_VIOLATION_CODE);
}
var NO_POLICY = { write: {}, read: {}, readable: true };
var AXIS_TIERS = {
  write: POLICY_WRITE_TIERS,
  read: POLICY_READ_TIERS
};
function isPolicyResource(value) {
  return POLICY_RESOURCES.includes(value);
}
function isPolicyRung(value) {
  return POLICY_RUNGS.includes(value);
}
function enforcedPolicyFromWire(body) {
  if (!body || typeof body !== "object") return { ...NO_POLICY, readable: false };
  const raw = body;
  const out = { write: {}, read: {}, readable: raw.readable !== false };
  for (const axis of ["write", "read"]) {
    const rules = raw.visibility?.[axis];
    if (!rules || typeof rules !== "object") continue;
    for (const [resource, rule] of Object.entries(rules)) {
      if (!isPolicyResource(resource) || !rule || !Array.isArray(rule.allowed)) continue;
      const allowed = AXIS_TIERS[axis].filter((tier) => rule.allowed.includes(tier));
      const setBy = (Array.isArray(rule.set_by) ? rule.set_by : []).filter(isPolicyRung);
      out[axis][resource] = { allowed, setBy };
    }
  }
  return out;
}
function resolveEnforcedPolicy(documents) {
  const out = { write: {}, read: {}, readable: true };
  for (const rung of POLICY_RUNGS) {
    const visibility = documents[rung]?.visibility;
    if (!visibility) continue;
    for (const axis of ["write", "read"]) {
      for (const [resource, tiers] of Object.entries(visibility[axis] ?? {})) {
        if (!isPolicyResource(resource) || !Array.isArray(tiers) || tiers.length === 0) continue;
        const rules = out[axis];
        const previous = rules[resource];
        const pool = previous ? previous.allowed : AXIS_TIERS[axis];
        rules[resource] = {
          allowed: pool.filter((tier) => tiers.includes(tier)),
          setBy: [...previous?.setBy ?? [], rung]
        };
      }
    }
  }
  return out;
}
function enforcedRule(policy, axis, resource) {
  return policy?.[axis]?.[resource];
}
function narrow(offered, fallbackDefault, rule) {
  if (!rule) return { offered: [...offered], defaultValue: fallbackDefault, blocked: false };
  const kept = offered.filter((tier) => rule.allowed.includes(tier));
  if (kept.length === 0) {
    return { offered: [], defaultValue: fallbackDefault, blocked: true };
  }
  return {
    offered: kept,
    // The product default survives when still allowed; otherwise the narrowest
    // allowed rung — the least-sharing choice is the safe one to start from.
    defaultValue: kept.includes(fallbackDefault) ? fallbackDefault : kept[0],
    blocked: false
  };
}
function applyEnforcedPolicy(policies, enforced) {
  if (!enforced) return policies;
  const touched = /* @__PURE__ */ new Set([
    ...Object.keys(enforced.write),
    ...Object.keys(enforced.read)
  ]);
  if (touched.size === 0) return policies;
  const out = { ...policies };
  for (const resource of touched) {
    const base = policies[resource];
    if (!base) continue;
    const writeRule = enforced.write[resource];
    const readRule = enforced.read[resource];
    const write = narrow(base.writeScopes, base.defaultWriteScope, writeRule);
    const read = narrow(base.resolveScopes, base.defaultResolveScope, readRule);
    out[resource] = {
      ...base,
      writeScopes: write.offered,
      defaultWriteScope: write.defaultValue,
      resolveScopes: read.blocked ? base.resolveScopes.slice(0, 1) : read.offered,
      defaultResolveScope: read.blocked ? base.resolveScopes[0] ?? base.defaultResolveScope : read.defaultValue,
      ...writeRule ? { enforcedWrite: writeRule } : {},
      ...readRule ? { enforcedRead: readRule } : {},
      ...write.blocked ? { writeBlocked: true } : {}
    };
  }
  return out;
}
function enforcedWriteOf(policy) {
  return policy.enforcedWrite;
}
function enforcedReadOf(policy) {
  return policy.enforcedRead;
}
function isWriteBlocked(policy) {
  return policy.writeBlocked === true;
}
var POLICY_RUNG_LABEL = {
  customer: "customer account",
  org: "organization",
  tenant: "tenant"
};
function enforcedBySentence(rule) {
  const rung = rule?.setBy[rule.setBy.length - 1];
  return rung ? `Enforced by your ${POLICY_RUNG_LABEL[rung]}` : "Enforced by your administrator";
}

// src/attribution/prefs.ts
var READ_ONLY_SCOPE_PREFS = {
  writeScope: {},
  resolveScope: {},
  setWriteScope: () => {
  },
  setResolveScope: () => {
  }
};
var SCOPE_SOURCE_LABEL = {
  user: "your choice",
  workspace: "set by your workspace",
  plan: "set by your plan",
  product: "product default",
  policy: "enforced by your administrator"
};
function inheritedDefault(layers, pick, resource, offered, productDefault) {
  for (let i = (layers?.length ?? 0) - 1; i >= 0; i -= 1) {
    const layer = layers[i];
    const candidate = pick(layer)?.[resource];
    if (candidate && offered.includes(candidate)) {
      return { value: candidate, source: layer.source };
    }
  }
  return { value: productDefault, source: "product" };
}
function withEnforcement(answer, rule, offeredCount) {
  if (!rule) return { ...answer, locked: false };
  const locked = offeredCount <= 1;
  return {
    ...answer,
    source: locked ? "policy" : answer.source,
    locked,
    enforced: rule
  };
}
function effectiveScopes(prefs, policies) {
  const resolveWrite = (resource) => {
    const policy = policyFor(resource, policies);
    const below = inheritedDefault(
      prefs.managed,
      (layer) => layer.writeScope,
      resource,
      policy.writeScopes,
      policy.defaultWriteScope
    );
    const own = prefs.writeScope[resource];
    const mine = own && policy.writeScopes.includes(own) ? own : null;
    return withEnforcement(
      {
        value: mine ?? below.value,
        source: mine ? "user" : below.source,
        inherited: below.value,
        inheritedSource: below.source
      },
      enforcedWriteOf(policy),
      policy.writeScopes.length
    );
  };
  const resolveRead = (resource) => {
    const policy = policyFor(resource, policies);
    const below = inheritedDefault(
      prefs.managed,
      (layer) => layer.resolveScope,
      resource,
      policy.resolveScopes,
      policy.defaultResolveScope
    );
    const own = prefs.resolveScope[resource];
    const mine = own && policy.resolveScopes.includes(own) ? own : null;
    return withEnforcement(
      {
        value: mine ?? below.value,
        source: mine ? "user" : below.source,
        inherited: below.value,
        inheritedSource: below.source
      },
      enforcedReadOf(policy),
      policy.resolveScopes.length
    );
  };
  return {
    writeScope: (resource) => resolveWrite(resource).value,
    readScope: (resource) => resolveRead(resource).value,
    isWriteOverridden: (resource) => resolveWrite(resource).source === "user",
    isReadOverridden: (resource) => resolveRead(resource).source === "user",
    resolveWrite,
    resolveRead
  };
}

// src/attribution/scored.ts
function isDefaultedConfidence(confidence) {
  return isDefaultedField({ confidence }, "confidence");
}
function scoredConfidence(confidence, metadata) {
  return recordedConfidence({ ...metadata, confidence }) ?? void 0;
}
function scoredAttributionItem(item) {
  if (scoredConfidence(item.confidence, item) !== void 0) return item;
  const { confidence: _dropped, ...rest } = item;
  return rest;
}
function scoredItems(items) {
  return (items ?? []).map(scoredAttributionItem);
}
function scoredAttributionBundle(bundle) {
  return {
    ...bundle,
    entities: scoredItems(bundle.entities),
    tags: scoredItems(bundle.tags),
    labels: scoredItems(bundle.labels),
    groups: scoredItems(bundle.groups)
  };
}
function scoredOverlayBundle(overlays) {
  return scoredAttributionBundle(overlayAttributionBundle(overlays));
}

export { ASSIGNMENT_ATTRIBUTE_KEYS, ATTRIBUTION_KINDS, BUNDLE_KEY, CANDIDATE_LIMIT, IneligibleAttributionError, KIND_LABEL, KIND_LABEL_PLURAL, MAX_BULK_SUBJECTS, NO_ATTACHMENTS, NO_POLICY, POLICY_READ_TIERS, POLICY_RESOURCES, POLICY_RUNGS, POLICY_RUNG_LABEL, POLICY_VIOLATION_CODE, POLICY_WRITE_TIERS, READ_ONLY_SCOPE_PREFS, SCOPE_SOURCE_LABEL, TX_PATCH_FIELDS, UnsupportedSubjectError, WRITABLE_SUBJECT_KINDS, addressRef, applyEnforcedPolicy, applyToMany, attachedFromAssignments, attachedFromCatalogBlock, attributionBundle, attributionCandidateLoader, attributionCapability, attributionRejection, capabilityAccepts, catalogChipsFrom, clearedAttributes, clearedWireNames, createAttributionWriter, effectiveScopes, effectiveWriteScope, enforcedBySentence, enforcedPolicyFromWire, enforcedReadOf, enforcedRule, enforcedWriteOf, foldPrimaryEntity, isDefaultedConfidence, isVisibilityPolicyRefusal, isWritableSubject, isWriteBlocked, missingRequired, namedAttributionBundle, outcomeMessage, overlayAttributionBundle, planAttribution, pruneToCapability, readGlassBoxProvenance, readHintState, recordVisibility, recordVisibilityReport, resolveEnforcedPolicy, restVisibility, scoredAttributionBundle, scoredAttributionItem, scoredConfidence, scoredOverlayBundle, subjectChainId, subjectKey, subjectTargetId, surfaceHintState, toAttributionCandidate, toCatalogChip, toGraphqlInput, toRestBody, toTxAttach, txPatchBody, writeHintState };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map